import React from "react";
import { NumericFormat } from "react-number-format";

export const NumericFormatCurrency = React.forwardRef(function NumericFormatCurrency(
  { onChange, name, ...other },
  ref
) {
  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale
      allowNegative={false}
      prefix="R$ "
      inputMode="decimal"
      onValueChange={(vals) => {
        onChange?.({ target: { name, value: vals.floatValue ?? "" } });
      }}
    />
  );
});

export const NumericFormatUnit = React.forwardRef(function NumericFormatUnit(
  { onChange, name, decimalScale = 2, ...other },
  ref
) {
  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={decimalScale}
      allowNegative={false}
      inputMode="decimal"
      onValueChange={(vals) => {
        onChange?.({ target: { name, value: vals.floatValue ?? "" } });
      }}
    />
  );
});
